import Box from "@mui/material/Box";

export function SupportText({ textOverride }: { textOverride?: string }) {
  return (
    <Box component="span" sx={{ fontWeight: 600, fontSize: "10px" }}>
      {textOverride || "Source Added"}
    </Box>
  );
}
